import { useMutation } from "urql";

import { CreateIdpFdDocument } from "../../../graphql/generated.ts";

export function useCreateIdpFdDocument() {
  return useMutation(CreateIdpFdDocument);
}
